import React from 'react';
import ServiceLandingPage, { ServiceConfig } from '../components/ServiceLandingPage';

const config: ServiceConfig = {
  name: 'Screen Replacement',
  icon: '📱',
  tagline: 'Cracked or broken screen? Get it replaced at your doorstep in under an hour.',
  description: 'A cracked or unresponsive screen doesn\'t have to ruin your day. Minto\'s certified technicians come to your home or office across Mumbai with genuine OEM screens and replace them on the spot. We handle all models — iPhone, Samsung, OnePlus, Vivo, Oppo, Realme and more. Most screen replacements are completed in 30–60 minutes with no data loss.',
  price: '999',
  warranty: '90-Day',
  benefits: [
    { icon: '🏠', title: 'Doorstep Service', desc: 'Technician comes to your location — home, office or café.' },
    { icon: '⚡', title: 'Same Day Repair', desc: 'Book before 6 PM and get your screen replaced today.' },
    { icon: '🛡️', title: '90-Day Warranty', desc: 'All screen replacements backed by 90 days warranty on parts & labour.' },
    { icon: '🔍', title: 'Genuine OEM Parts', desc: 'We use high-quality OEM screens — no cheap aftermarket parts.' },
    { icon: '💾', title: 'Zero Data Loss', desc: 'Your data stays safe — we only replace the screen, nothing else.' },
    { icon: '💰', title: 'Transparent Pricing', desc: 'Price shown upfront before booking. No hidden charges.' },
  ],
  brands: ['iPhone', 'Samsung', 'OnePlus', 'Vivo', 'Oppo', 'Realme', 'Motorola', 'Xiaomi', 'Nothing', 'Google Pixel', 'Honor', 'Asus'],
  faqs: [
    { q: 'How long does a screen replacement take?', a: 'Most screen replacements take 30–60 minutes at your location.' },
    { q: 'Will my data be safe?', a: 'Yes. Screen replacement does not affect your data in any way.' },
    { q: 'Do you use original screens?', a: 'We use high-quality OEM screens. Fully original OEM screens are available at a premium — ask at the time of booking.' },
    { q: 'What if the screen has issues after replacement?', a: 'All our repairs come with a 90-day warranty. If anything goes wrong, we\'ll fix it for free.' },
    { q: 'Which areas in Mumbai do you cover?', a: 'We cover all major areas including Andheri, Bandra, Dadar, Lower Parel, Borivali, Malad, Goregaon, Vile Parle, Ghatkopar, Kurla, Thane, Chembur and Navi Mumbai.' },
  ],
};

const ScreenReplacementPage: React.FC = () => <ServiceLandingPage config={config} />;
export default ScreenReplacementPage;
